import { render, staticRenderFns } from "./CruiseDetailNav.vue?vue&type=template&id=132d2e50&scoped=true"
import script from "./CruiseDetailNav.vue?vue&type=script&lang=js"
export * from "./CruiseDetailNav.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailNav.vue?vue&type=style&index=0&id=132d2e50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d2e50",
  null
  
)

export default component.exports